import officeApiGetAsync from './infrastructure/office-api-get-async'

export async function officeApiEvent_StartGetAsync(): Promise<Date> {
  return officeApiGetAsync<Date>(
    '1.1',
    'start.getAsync',
    () => new Promise<Office.AsyncResult<Date>>((resolve) => Office.context.mailbox.item.start.getAsync(resolve)),
    null,
  )
}

export async function officeApiEvent_EndGetAsync(): Promise<Date> {
  return officeApiGetAsync<Date>(
    '1.1',
    'end.getAsync',
    () => new Promise<Office.AsyncResult<Date>>((resolve) => Office.context.mailbox.item.end.getAsync(resolve)),
    null,
  )
}

export async function officeApiEvent_LocationGetAsync(): Promise<string> {
  return officeApiGetAsync<string>(
    '1.1',
    'location.getAsync',
    () => new Promise<Office.AsyncResult<string>>((resolve) => Office.context.mailbox.item.location.getAsync(resolve)),
    null,
  )
}

export async function officeApiEvent_OrganizerGetAsync(): Promise<Office.EmailAddressDetails> {
  return officeApiGetAsync<Office.EmailAddressDetails>(
    '1.7',
    'organizer.getAsync',
    () => new Promise<Office.AsyncResult<Office.EmailAddressDetails>>((resolve) => Office.context.mailbox.item.organizer.getAsync(resolve)),
    null,
  )
}

export async function officeApiEvent_RequiredAttendeesGetAsync(): Promise<Office.EmailAddressDetails[]> {
  return officeApiGetAsync<Office.EmailAddressDetails[]>(
    '1.1',
    'requiredAttendees.getAsync',
    () => new Promise<Office.AsyncResult<Office.EmailAddressDetails[]>>((resolve) => Office.context.mailbox.item.requiredAttendees.getAsync(resolve)),
    [],
  )
}

export async function officeApiEvent_OptionalAttendeesGetAsync(): Promise<Office.EmailAddressDetails[]> {
  return officeApiGetAsync<Office.EmailAddressDetails[]>(
    '1.1',
    'optionalAttendees.getAsync',
    () => new Promise<Office.AsyncResult<Office.EmailAddressDetails[]>>((resolve) => Office.context.mailbox.item.optionalAttendees.getAsync(resolve)),
    [],
  )
}
